/**
 * @generated SignedSource<<bfe1a063f9c3dee53e0ce29c41b55e19>>
 * @relayHash 4904f7cdc8e6a902778256166e661f7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03584fde98790a7e63f8ca85b13f2405c35faeb9ebc3dd7e7bd6286ce6193785

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessCalendarEntrypointQuery } from './JiraBusinessCalendarEntrypointQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessCalendarEntrypointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "03584fde98790a7e63f8ca85b13f2405c35faeb9ebc3dd7e7bd6286ce6193785",
    "metadata": {},
    "name": "JiraBusinessCalendarEntrypointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
